module.exports = __webpack_public_path__ + "static/img/doublelift.0e2f84c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/coach/doublelift.png
// module id = YrpZ
// module chunks = 35